import useTranslation from "@hooks/use_translation.ts";
import { Error } from "@components/error.tsx";
import { JobAlertsHeader } from "@components/job_alerts/header.tsx";

export const ErrorState = () => {
  const { t } = useTranslation("jobAlerts");

  return (
    <>
      <JobAlertsHeader />
      <Error header={t("errorLoadingJobAlerts")} fullPage={false} />
    </>
  );
};
